enum LanguageCode {
  English = 'en',
  Español = 'es',
  Arabic = 'ar',
}
export default LanguageCode;
